import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import BlogSingle from '../../components/BlogDetails/BlogDetails';
import axios from 'axios';
import { useSeo } from '../../hooks/useSeo';

const staticMeta = {
  title: 'Blog | RashTech Info',
  description: 'Read detailed articles and insights from RashTech Info on engineering, design, product, and growth.',
  url: 'https://rashtechinfo.com/blog',
  image: 'https://rashtechinfo.com/og-image.png',
  siteName: 'RashTech Info',
  keywords: 'blog, article, tutorial, engineering, design, product, RashTech Info',
  themeColor: '#0A0D1C',
};

const BlogDetails = () => {
  const { id } = useParams();
  const [blogData, setBlogData] = useState([]);
  const decodedTitle = encodeURIComponent(id.replace(/-/g, " "));
  console.log('Decoded title:', decodedTitle);
  console.log('Blog ID from URL:', id);

  const { seo } = useSeo('/getSeo');

  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };

    const bTitle = blogData?.blog_title || blogData?.title;
    const bDesc =
      blogData?.meta_description ||
      blogData?.excerpt ||
      blogData?.short_description ||
      blogData?.blog_description;

    return {
      title: bTitle ? `${bTitle} | Blog | RashTech Info` : dynamic.title || staticMeta.title,
      description: bDesc || dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || (decodedTitle ? `https://rashtechinfo.com/blog_details/${decodedTitle}` : staticMeta.url),
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo, blogData, decodedTitle]);


  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`https://api.rashtechinfo.com/getBlogById/${decodedTitle}`);
        const data = response.data;
        console.log('Fetched blog data:', data);
        setBlogData(data);
      } catch (error) {
        console.error(error);
      }
    };
    if (decodedTitle) fetchBlog();
  }, [decodedTitle]);

  return (
    <Fragment>
      <Helmet>
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}

        <meta property="og:type" content="article" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}
      </Helmet>

      <Header />
      <main className="page_content about-page">
        <PageTitle pageTitle={blogData.blog_title} pagesub={'Details'} pageTop={'Blog'}/>
        <BlogSingle/>
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
};
export default BlogDetails;
